export const COLUMN_STORAGE_KEY = "user-contract-asset-monitor-columns";
export const DAILY_COLUMN_STORAGE_KEY =
  "user-contract-asset-monitor-daily-columns";

export const TABLE_COLUMNS = [
  { prop: "uid", label: "UID", minWidth: 110 },
  { prop: "registerTime", label: "注册时间", minWidth: 165, type: "datetime" },
  { prop: "userType", label: "用户类型", minWidth: 100, type: "userType" },
  { prop: "topPartnerUid", label: "顶级合伙人UID", minWidth: 135 },
  {
    prop: "topPartnerRebateRate",
    label: "顶级合伙人合约返佣比例",
    minWidth: 185,
    type: "ratio",
  },
  { prop: "kycStatus", label: "KYC状态", minWidth: 100, type: "kycStatus" },
  { prop: "kycTime", label: "KYC时间", minWidth: 165, type: "datetime" },
  {
    prop: "rebateRiskStatus",
    label: "返佣风控状态",
    minWidth: 120,
    type: "riskStatus",
  },
  { prop: "riskRemark", label: "风控备注", minWidth: 150 },
  {
    prop: "spotBalanceUsdt",
    label: "现货账户余额（USDT）",
    minWidth: 175,
    type: "amount",
    detailType: "spotBalance",
  },
  {
    prop: "contractBalanceUsdt",
    label: "合约账户余额（USDT）",
    minWidth: 175,
    type: "amount",
  },
  {
    prop: "copyBalanceUsdt",
    label: "跟单账户余额（USDT）",
    minWidth: 175,
    type: "amount",
  },
  {
    prop: "avgHoldingHours",
    label: "平均持仓时间（小时）",
    minWidth: 165,
    type: "decimal",
  },
  {
    prop: "holdingLe3mRate",
    label: "3分钟以内持仓时间占比",
    minWidth: 180,
    type: "rate",
  },
  {
    prop: "holdingLe10mRate",
    label: "10分钟以内持仓时间占比",
    minWidth: 185,
    type: "rate",
  },
  { prop: "cancelRate", label: "撤单率", minWidth: 100, type: "rate" },
  { prop: "openCount", label: "开仓次数", minWidth: 100 },
  { prop: "closeCount", label: "平仓次数", minWidth: 100 },
  { prop: "tradeCount", label: "交易次数", minWidth: 100 },
  { prop: "profitableCloseCount", label: "盈利平仓次数", minWidth: 120 },
  {
    prop: "profitableCloseRate",
    label: "平仓盈利率",
    minWidth: 110,
    type: "rate",
  },
  { prop: "contractSymbols", label: "合约交易币种", minWidth: 160 },
  { prop: "orderIps", label: "合约下单IP", minWidth: 180 },
  {
    prop: "depositAmountUsdt",
    label: "充值金额（USDT）",
    minWidth: 155,
    type: "amount",
    detailType: "deposit",
  },
  {
    prop: "withdrawAmountUsdt",
    label: "提现金额（USDT）",
    minWidth: 155,
    type: "amount",
    detailType: "withdraw",
  },
  {
    prop: "netDepositAmountUsdt",
    label: "净充值金额（USDT）",
    minWidth: 165,
    type: "amount",
    detailType: "netDeposit",
  },
  {
    prop: "contractTotalFeeUsdt",
    label: "合约总手续费（USDT）",
    minWidth: 175,
    type: "amount",
  },
  {
    prop: "totalContributionRebateUsdt",
    label: "总贡献返佣金额（USDT）",
    minWidth: 190,
    type: "amount",
    detailType: "contributionRebate",
  },
  {
    prop: "subordinateContributionRebateUsdt",
    label: "下级贡献返佣金额（USDT）",
    minWidth: 200,
    type: "amount",
    detailType: "subordinateContribution",
  },
  {
    prop: "grantedLeaderProfitUsdt",
    label: "已发放带单分润（USDT）",
    minWidth: 185,
    type: "amount",
  },
];

export const DAILY_TABLE_COLUMNS = [
  { prop: "uid", label: "UID", minWidth: 110 },
  { prop: "statisticsDate", label: "统计日期", minWidth: 125, type: "date" },
  { prop: "userType", label: "用户类型", minWidth: 105, type: "userType" },
  { prop: "topPartnerUid", label: "顶级合伙人UID", minWidth: 135 },
  {
    prop: "topPartnerRebateRate",
    label: "顶级合伙人返佣比例",
    minWidth: 165,
    type: "ratio",
  },
  { prop: "cancelRate", label: "撤单率", minWidth: 100, type: "rate" },
  { prop: "openCount", label: "开仓次数", minWidth: 100 },
  { prop: "closeCount", label: "平仓次数", minWidth: 100 },
  { prop: "tradeCount", label: "交易次数", minWidth: 100 },
  { prop: "profitableCloseCount", label: "盈利平仓次数", minWidth: 120 },
  {
    prop: "profitableCloseRate",
    label: "平仓盈利率",
    minWidth: 110,
    type: "rate",
  },
  { prop: "contractSymbols", label: "合约交易币种", minWidth: 150 },
  { prop: "orderIps", label: "合约下单IP", minWidth: 165 },
  {
    prop: "depositAmountUsdt",
    label: "充值金额（USDT）",
    minWidth: 155,
    type: "amount",
  },
  {
    prop: "withdrawAmountUsdt",
    label: "提现金额（USDT）",
    minWidth: 155,
    type: "amount",
  },
  {
    prop: "netDepositAmountUsdt",
    label: "净充值金额（USDT）",
    minWidth: 165,
    type: "amount",
  },
  {
    prop: "contractTotalFeeUsdt",
    label: "合约总手续费（USDT）",
    minWidth: 175,
    type: "amount",
  },
  {
    prop: "totalContributionRebateUsdt",
    label: "总贡献返佣（USDT）",
    minWidth: 165,
    type: "amount",
  },
  {
    prop: "subordinateContributionRebateUsdt",
    label: "下级贡献返佣（USDT）",
    minWidth: 175,
    type: "amount",
  },
  {
    prop: "grantedLeaderProfitUsdt",
    label: "已发放带单分润（USDT）",
    minWidth: 185,
    type: "amount",
  },
];

export function createDefaultColumns(definitions = TABLE_COLUMNS) {
  return definitions.map((column) => ({ ...column, visible: true }));
}

export function restoreColumns(
  storageKey = COLUMN_STORAGE_KEY,
  definitions = TABLE_COLUMNS,
) {
  const defaults = createDefaultColumns(definitions);
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || "[]");
    if (!Array.isArray(saved) || !saved.length) return defaults;
    const savedMap = saved.reduce((map, item) => {
      if (item && item.prop) map[item.prop] = item;
      return map;
    }, {});
    const ordered = saved
      .map((item) => defaults.find((column) => column.prop === item.prop))
      .filter(Boolean)
      .map((column) => ({
        ...column,
        visible: savedMap[column.prop].visible !== false,
      }));
    defaults.forEach((column) => {
      if (!savedMap[column.prop]) ordered.push(column);
    });
    return ordered;
  } catch (error) {
    return defaults;
  }
}

export function saveColumns(columns, storageKey = COLUMN_STORAGE_KEY) {
  localStorage.setItem(
    storageKey,
    JSON.stringify(columns.map(({ prop, visible }) => ({ prop, visible }))),
  );
}
